import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import RawMetric from './raw-metric-model'
import {
  CreateRawMetricAsync,
  DeleteRawMetricAsync,
  LoadRawMetricsAsync,
} from './rawMetric-thunk'
const initialState: rawMetricSliceState = {
  rawMetric: [],
  selected_rawMetric: '',
  is_loading_rawMetric: false,
  is_creating_rawMetric: false,
  is_deleting_rawMetric: false,
}
export interface rawMetricSliceState {
  rawMetric: RawMetric[]
  selected_rawMetric?: string
  is_loading_rawMetric: boolean
  is_creating_rawMetric: boolean
  is_deleting_rawMetric: boolean
}
export const rawMetricSlice = createSlice({
  name: 'rawMetric',
  initialState,
  reducers: {
    setSelectedrawMetric: (state, action) => {
      state.selected_rawMetric = action.payload
    },
    clearStaterawMetric: (state) => {
      state.rawMetric = []
      state.is_loading_rawMetric = false
      state.is_creating_rawMetric = false
      state.is_deleting_rawMetric = false
    },
    mergerawMetric: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_rawMetric = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.rawMetric = merge(state.rawMetric, payload) as any
        }
      }
    },

    add_rawMetric: (state, action) => {
      if (action.payload) {
        state.rawMetric = [...state.rawMetric, action.payload]
      }
    },
    set_rawMetric: (state, action) => {
      let { key, value, id } = action.payload
      state.rawMetric = state.rawMetric.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadRawMetricsAsync.pending, (state) => {
      state.is_loading_rawMetric = true
    })
    builder.addCase(LoadRawMetricsAsync.fulfilled, (state, action) => {
      state.is_loading_rawMetric = false
      if (action.payload) {
        state.rawMetric = action.payload
      }
    })
    builder.addCase(LoadRawMetricsAsync.rejected, (state) => {
      state.is_loading_rawMetric = false
    })
    builder.addCase(CreateRawMetricAsync.pending, (state) => {
      state.is_creating_rawMetric = true
    })
    builder.addCase(CreateRawMetricAsync.fulfilled, (state) => {
      state.is_creating_rawMetric = false
    })
    builder.addCase(CreateRawMetricAsync.rejected, (state) => {
      state.is_creating_rawMetric = false
    })
    builder.addCase(DeleteRawMetricAsync.pending, (state) => {
      state.is_deleting_rawMetric = true
    })
    builder.addCase(DeleteRawMetricAsync.fulfilled, (state, action) => {
      state.is_deleting_rawMetric = false
      if (state.rawMetric) {
        state.rawMetric = state.rawMetric.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteRawMetricAsync.rejected, (state) => {
      state.is_deleting_rawMetric = false
    })
  },
})

export const {
  clearStaterawMetric,
  setSelectedrawMetric,
  set_rawMetric,
  mergerawMetric,
  add_rawMetric,
} = rawMetricSlice.actions

export const get_rawMetric =
  (id?: string) =>
  (state: {
    rawMetric: {
      rawMetric: RawMetric[]
    }
  }): RawMetric | null => {
    let temp = state?.rawMetric?.rawMetric?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.rawMetric?.rawMetric[0] || null
  }
export const get_selected_rawMetric = (state: {
  rawMetric: rawMetricSliceState
}): RawMetric | null => {
  let id = state?.rawMetric?.selected_rawMetric
  let temp = state?.rawMetric?.rawMetric?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_rawMetric = (state: {
  rawMetric: {
    rawMetric: RawMetric[]
  }
}): RawMetric[] => {
  let temp = state?.rawMetric?.rawMetric
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_rawMetric_busy = (state: {
  rawMetric: rawMetricSliceState
}) => {
  return (
    state?.rawMetric.is_deleting_rawMetric ||
    state?.rawMetric.is_loading_rawMetric ||
    state?.rawMetric.is_creating_rawMetric
  )
}
export const is_deleting_rawMetric_busy = (state: {
  rawMetric: rawMetricSliceState
}) => {
  return state?.rawMetric.is_deleting_rawMetric
}
export const is_loading_rawMetric_busy = (state: {
  rawMetric: rawMetricSliceState
}) => {
  return state?.rawMetric.is_loading_rawMetric
}
export const is_creating_rawMetric_busy = (state: {
  rawMetric: rawMetricSliceState
}) => {
  return state?.rawMetric.is_creating_rawMetric
}

export default rawMetricSlice.reducer
